// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--U9DD9","slider":"da51a739f7--slider--HYvjW","discounts":"da51a739f7--discounts--ZC4tz"};